<template>
  <div class="calendar-month">
    <div class="calendar-month-header">
      <CalendarDateIndicator
          :selected-date="selectedDate"
          class="calendar-month-header-selected-month"
      />

      <CalendarDateSelector
          :current-date="today"
          :selected-date="selectedDate"
          @dateSelected="selectDate"
      />
    </div>
    <CalendarWeekdays/>
    <ol class="days-grid">
      <CalendarMonthDayItem
          v-for="day in days"
          :key="day.date"
          :day="day"
          :is-today="day.date === today"
          :dayDetails="getDayData(day.date)"
          @openDailyMenuModal="manageDailyModal"
      />
    </ol>

    <div class="centerx">
      <vs-popup classContent="addDailyMenuModal" title="Új napi menü hozzáadása" :active.sync="addModal"
                @closemodal="closeModal">
        <new_daily_menu v-bind:selected="selectedMenu" v-bind:itemData="itemData" @itemAdded="refreshDatasource()"></new_daily_menu>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editDailyMenuModal" title="Napi menü módosítása" :active.sync="editModal"
                @closemodal="closeModal">
        <edit_daily_menu v-bind:selected="selectedMenu" v-bind:itemData="itemData" @itemAdded="refreshDatasource()"></edit_daily_menu>
      </vs-popup>
    </div>


  </div>
</template>

<script>
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import CalendarMonthDayItem from "./CalendarMonthDayItem";
import CalendarDateIndicator from "./CalendarDateIndicator";
import CalendarDateSelector from "./CalendarDateSelector";
import CalendarWeekdays from "./CalendarWeekdays";
import new_daily_menu from "../modals/new_daily_menu";
import edit_daily_menu from "../modals/edit_daily_menu";
import {axiosInstance} from "@/main";
import 'dayjs/locale/hu';

dayjs.extend(weekday);
dayjs.extend(weekOfYear);

export default {
  name: "CalendarMonth",

  props: ["refreshEvent"],

  components: {
    edit_daily_menu,
    new_daily_menu,
    CalendarMonthDayItem,
    CalendarDateIndicator,
    CalendarDateSelector,
    CalendarWeekdays
  },

  watch: {
    refreshEvent() {
      if (this.refreshEvent) {
        this.getDailyMenuContent();
        this.$emit('finished');
      }
    }
  },

  data() {
    return {
      addModal: false,
      editModal: false,
      selectedDate: dayjs().locale('hu'),
      dayData: null,
      itemData: [],
      dailyMenu: [],
      selectedMenu: {
        Id: null,
        IdSoup: null,
        IdMainA: null,
        IdMainB: null,
        MenuDate: null,
        IdImage: null,
        IdExtra: null
      }
    };
  },

  computed: {
    days() {
      return [
        ...this.previousMonthDays,
        ...this.currentMonthDays,
        ...this.nextMonthDays
      ];
    },

    today() {
      return dayjs().format("YYYY-MM-DD");
    },

    month() {
      return Number(this.selectedDate.format("M"));
    },

    year() {
      return Number(this.selectedDate.format("YYYY"));
    },

    numberOfDaysInMonth() {
      return dayjs(this.selectedDate).daysInMonth();
    },

    currentMonthDays() {
      return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
        return {
          date: dayjs(`${this.year}-${this.month}-${index + 1}`).format(
              "YYYY-MM-DD"
          ),
          isCurrentMonth: true
        };
      });
    },

    previousMonthDays() {
      const firstDayOfTheMonthWeekday = this.getWeekday(
          this.currentMonthDays[0].date
      );
      const previousMonth = dayjs(`${this.year}-${this.month}-01`).subtract(
          1,
          "month"
      );

      // Cover first day of the month being sunday (firstDayOfTheMonthWeekday === 0)
      const visibleNumberOfDaysFromPreviousMonth = firstDayOfTheMonthWeekday
          ? firstDayOfTheMonthWeekday - 1
          : 6;

      const previousMonthLastMondayDayOfMonth = dayjs(
          this.currentMonthDays[0].date
      )
          .subtract(visibleNumberOfDaysFromPreviousMonth, "day")
          .date();

      return [...Array(visibleNumberOfDaysFromPreviousMonth)].map(
          (day, index) => {
            return {
              date: dayjs(
                  `${previousMonth.year()}-${previousMonth.month() +
                  1}-${previousMonthLastMondayDayOfMonth + index}`
              ).format("YYYY-MM-DD"),
              isCurrentMonth: false
            };
          }
      );
    },

    nextMonthDays() {
      const lastDayOfTheMonthWeekday = this.getWeekday(
          `${this.year}-${this.month}-${this.currentMonthDays.length}`
      );

      const nextMonth = dayjs(`${this.year}-${this.month}-01`).add(1, "month");

      const visibleNumberOfDaysFromNextMonth = lastDayOfTheMonthWeekday
          ? 7 - lastDayOfTheMonthWeekday
          : lastDayOfTheMonthWeekday;

      return [...Array(visibleNumberOfDaysFromNextMonth)].map((day, index) => {
        return {
          date: dayjs(
              `${nextMonth.year()}-${nextMonth.month() + 1}-${index + 1}`
          ).format("YYYY-MM-DD"),
          isCurrentMonth: false
        };
      });
    }
  },

  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getDailyMenuContent();
    },
    getWeekday(date) {
      return dayjs(date).weekday();
    },
    selectDate(newSelectedDate) {
      this.selectedDate = newSelectedDate;
      this.getDailyMenuContent()
    },
    getDailyMenuContent() {
      let self = this;
      self.$vs.loading({type: 'border', text: 'Betöltés'});
      Promise.all([
        axiosInstance.get('admin/dailyMenuController.php?date=' + dayjs(self.selectedDate).format("YYYY-MM-DD"), {
          withCredentials: true,
        }),
        axiosInstance.get('admin/dailyMenuItemController.php', {
          withCredentials: true,
        })])
          .then(results => {
            self.dailyMenu = results[0].data.responseData;
            self.itemData = results[1].data.responseData;
            self.$vs.loading.close();
          })
          .catch((err) => {
            if (err.response.status === 401) {
              self.$vs.loading.close();
              self.$root.exterminatus(err.response.data.message);
            }

            else {
              self.$vs.loading.close();
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    getDayData(date) {
      if (!this.dailyMenu || Object.keys(this.dailyMenu).length === 0) {
        return {
          Id: null,
          IdMainA: null,
          IdMainB: null,
          IdMainC: null,
          IdDiet: null,
          MenuDate: date,
          IdImage: null,
          IdExtra: null
        };
      } else {
        let dayData = this.dailyMenu.find(elem => elem.MenuDate === date);
        if (dayData) {

          if (dayData.IdMainA)
            dayData.aMainName = this.aMainName(dayData.IdMainA);
          else
            dayData.aMainName = 'Hiányzó A menü';

          if (dayData.IdMainB)
            dayData.bMainName = this.bMainName(dayData.IdMainB);
          else
            dayData.bMainName = 'Hiányzó B menü';

          if (dayData.IdMainC)
            dayData.cMainName = this.cMainName(dayData.IdMainC);
          else
            dayData.cMainName = 'Hiányzó Tej- és cukormentes menü';

          if (dayData.IdDiet)
            dayData.dietName = this.bMainName(dayData.IdDiet);
          else
            dayData.dietName = 'Hiányzó Epe kímélő menü';

          if (dayData.IdExtra)
            dayData.extraName = this.extraName(dayData.IdExtra);
          else
            dayData.extraName = 'Hiányzó extra';

          return dayData;
        }
      }
    },
    soupName(soupId) {
      let soup = this.itemData.find(elem => elem.ItemId === soupId)
      return !soup ? 'Hiányzó leves' : soup.ItemName;
    },
    aMainName(aMainId) {
      let mainA = this.itemData.find(elem => elem.ItemId === aMainId);
      return !mainA ? 'Hiányzó A menü' : mainA.ItemName;
    },
    bMainName(bMainId) {
      let mainB = this.itemData.find(elem => elem.ItemId === bMainId);
      return !mainB ? 'Hiányzó B menü' : mainB.ItemName;
    },
    cMainName(cMainId) {
      let mainC = this.itemData.find(elem => elem.ItemId === cMainId);
      return !mainC ? 'Hiányzó Tej- és cukormentes menü' : mainC.ItemName;
    },
    dietName(dietId) {
      let diet = this.itemData.find(elem => elem.ItemId === dietId);
      return !diet ? 'Hiányzó Epe kímélő menü' : diet.ItemName;
    },
    extraName(extraId) {
      let extra = this.itemData.find(elem => elem.ItemId === extraId);
      return !extra ? 'Hiányzó extra' : extra.ItemName;
    },
    manageDailyModal(payload) {
      this.selectedMenu = payload;
      if (!this.selectedMenu.Id)
        this.addModal = true;
      else
        this.editModal = true;
    },
    refreshDatasource() {
      this.getDailyMenuContent();
    }
  },
  created() {
    this.getDailyMenuContent();
    this.$parent.$on('itemCreated', this.getDailyMenuContent);
  }
};
</script>

<style scoped>
.calendar-month {
  position: relative;
  background-color: var(--grey-200);
  border: solid 1px var(--grey-300);
}

.day-of-week {
  color: var(--grey-800);
  font-size: 18px;
  background-color: #fff;
  padding-bottom: 5px;
  padding-top: 10px;
}

.day-of-week,
.days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.day-of-week > * {
  text-align: right;
  padding-right: 5px;
}

.days-grid {
  height: 100%;
  position: relative;
  grid-column-gap: var(--grid-gap);
  grid-row-gap: var(--grid-gap);
  border-top: solid 1px var(--grey-200);
}
</style>
